module.exports = __webpack_public_path__ + "img/type9999.d5fdd5ef.png";